<script>
import EventHeader from '@/components/customer/EventHeader.vue'
import { SET_CURRENT_MENU, UPDATE_EVENT_LIST_CONTENT } from '@/common/resources/const'
import { mapMutations } from 'vuex'

export default {
  name: 'EventView',
  components: {
    EventHeader
  },
  data () {
    return {
      componentKey: 0
    }
  },
  methods: {
    ...mapMutations([SET_CURRENT_MENU])
  },
  mounted () {
    this[SET_CURRENT_MENU]('customer')
    this.$events.$on(UPDATE_EVENT_LIST_CONTENT, () => {
      this.componentKey += 1
    })
  },
  beforeDestroy () {
    this.$events.$off(UPDATE_EVENT_LIST_CONTENT)
  }
}
</script>

<template>
  <div>
    <EventHeader />
    <RouterView
      name="customerContent"
      :key="`customer_${$route.name}_${componentKey}`"
    />
  </div>
</template>
